import { KioskStateType } from "../../KioskReducer"
import { ActionType } from "../../Actions"
import { DEFAULT_MODE_SET } from "../../Actions/Kiosk/defaultModeSetAction";
import { DEFAULT_MODE_RESET } from "../../Actions/Kiosk/defaultModeResetAction";
import { storageKeyDefaultMode } from "../../../model/StorageKeys";
import storeState from '../../../utils/storeState'
import { emptyState } from "../../../utils/storeState";

export default function defaultModeReducer(
  state: KioskStateType,
  action: ActionType
): KioskStateType {
  switch( action?.type ) {
    case DEFAULT_MODE_SET:
      storeState(storageKeyDefaultMode, action.payload.defaultMode);
      return {
        ...state,
        defaultMode: action.payload.defaultMode
      }
    case DEFAULT_MODE_RESET:
      emptyState(storageKeyDefaultMode);
      return {
        ...state,
        defaultMode: undefined
      }
    default: 
      return state;
  }
}
